var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNlu = function SvgNlu(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#404055"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M10.167 21.833c0 .458.375.833.833.833h6.117c.225.625.55 1.183.991 1.667H11a2.497 2.497 0 0 1-2.5-2.5c0-.5.15-.967.417-1.367l4.583-7.958v-1.509a.836.836 0 0 1-.833-.833v-.833c0-.917.75-1.667 1.666-1.667h3.334c.925 0 1.666.75 1.666 1.667v.833a.836.836 0 0 1-.833.833v1.509l2.083 3.641a5 5 0 0 0-1.508.684l-2.242-3.875V9.333h-1.666v3.625l-4.85 8.4a.85.85 0 0 0-.15.475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M19.166 17.666q.69 0 1.109.467.422.467.422 1.311t-.394 1.32-1.137.474q-.675 0-1.09-.474-.41-.476-.41-1.32.001-.844.386-1.311.39-.467 1.114-.467m.016.95q-.173 0-.241.23-.065.225-.065.614 0 .382.065.615.068.23.24.23.174 0 .238-.226.064-.23.064-.619 0-.39-.064-.615-.065-.23-.237-.23m4.445-.868-3.26 5.69h-1.193l3.26-5.69zm.008 2.183q.69 0 1.11.467.42.466.421 1.311 0 .841-.393 1.316-.394.474-1.138.474-.675 0-1.09-.474-.408-.475-.409-1.316 0-.844.386-1.311.39-.467 1.113-.467m.016.95q-.173 0-.24.229-.066.225-.065.615 0 .381.064.615.069.23.241.23.174 0 .237-.226.069-.23.069-.62 0-.404-.069-.622-.064-.222-.237-.222"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNlu);
export { ForwardRef as ReactComponent };